import { Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { IconInfoCircle } from '@tabler/icons-react-native';
import { useScopedTranslation } from 'app/hooks/i18n';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
import { theme } from './shared';

export const NewAddressHelp = ({ visible }: { visible: boolean }) => {
  const { t } = useScopedTranslation();
  if (!visible) return null;

  return (
    <Row
      gap="spacing.general.x2"
      padding="spacing.general.x4"
      style={{
        backgroundColor: theme.colors['surface.tertiary-neutral'],
        borderRadius: theme.borderRadii['radius.lg'],
      }}
    >
      <IconInfoCircle strokeWidth={ICON_STROKE_WIDTH} />
      <Text flex={1}>{t('addAddressHelp')}</Text>
    </Row>
  );
};
